var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"white--text",attrs:{"flat":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","color":"white"},on:{"click":function($event){return _vm.$emit('onClose')}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }